import { render, staticRenderFns } from "./MediaControlsLink.vue?vue&type=template&id=48f04e80&"
import script from "./MediaControlsLink.vue?vue&type=script&lang=js&"
export * from "./MediaControlsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports